import { getStagedFileCardState, StagedFileStatus } from '@/matter-asset-common/files/utils/get-staged-file-card-state'
import { TimelineFileStatus } from '../constants'
import type { UserFileRead } from '@/uppy-file-upload/schemas'
import type { FileUploadState } from '@/uppy-file-upload/store/slice'

const timelineStatus = {
  [StagedFileStatus.UPLOADING]: TimelineFileStatus.UPLOADING,
  [StagedFileStatus.PROCESSING]: TimelineFileStatus.PROCESSING,
  [StagedFileStatus.COMPLETED]: TimelineFileStatus.COMPLETED,
  [StagedFileStatus.ERROR]: TimelineFileStatus.ERROR,
} as const

export function getTimelineAssetFileCardState(params: { fileId?: string; file?: UserFileRead; uploadState?: FileUploadState; loadError?: boolean }) {
  // Preserve Timeline's ready fallback for statuses added by the backend.
  const state = getStagedFileCardState({ ...params, allowUnknownProcessingStatus: true })
  return { ...state, status: timelineStatus[state.status] }
}
